import React from 'react';
import { useTransformationLibTableContext } from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibTableContext';
import ClusterSelect from 'app/components/cluster-select';

function TransformationLibClusterSelect() {
  const { handleClusterChange } = useTransformationLibTableContext();
  return <ClusterSelect name="clusterId" size="small" variant="outlined" onChange={handleClusterChange} />;
}

export default TransformationLibClusterSelect;
